import { FieldFilter } from 'module/types/filter-field/filter';
import * as React from 'react';

interface Props {
  filter: FieldFilter;
  option: any;
}

export const CyWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  filter,
  option,
}) => {
  return (
    <span
      data-cy={`${filter?.field?.fieldLabel ?? '__new__'}.operations.${
        option.type
      }`}
      data-op="criteria.op_trigger"
      data-operation={`criteria.op_trigger.${filter.field.fieldName}`}
    >
      {children}
    </span>
  );
};
